// ─────────────────────────────────────────────
//  PercentageCalculator.jsx — Calculadora de Porcentajes
// ─────────────────────────────────────────────

import React, { useState, useCallback } from 'react';
import appStyles from '../layout/CalculatorPage.module.css';
import { formatCurrency } from '../../utils/format';
import { KEYS, getSetting } from '../../utils/storage';
import { DEFAULTS } from '../../utils/defaults';

import ModeSegment from './ModeSegment';
import PercentageAmountInput from './PercentageAmountInput';
import PercentageSlider from './PercentageSlider';
import PercentageSummary from './PercentageSummary';

const QUICK_PCTS = [5, 10, 16, 20, 25, 50];

function getDefaultPct() {
	return String(getSetting(KEYS.defaultPct, DEFAULTS.defaultPct));
}

function getDefaultMode() {
	return getSetting(KEYS.defaultPctMode, DEFAULTS.defaultPctMode);
}

export default function PercentageCalculator() {
	const [amount, setAmount] = useState('');
	const [pct, setPct] = useState(getDefaultPct);
	const [mode, setMode] = useState(getDefaultMode);

	const parsedAmount = parseFloat(amount) || 0;
	const parsedPct = parseFloat(pct) || 0;
	const hasAmount = parsedAmount > 0;

	let adjustment = 0;
	let finalAmount = 0;

	if (hasAmount) {
		adjustment = parsedAmount * (parsedPct / 100);
		finalAmount = mode === 'discount'
			? parsedAmount - adjustment
			: parsedAmount + adjustment;
	}

	const handleReset = useCallback(() => {
		setAmount('');
		setPct(getDefaultPct());
		setMode(getDefaultMode());
	}, []);

	return (
		<main className={appStyles.root} aria-label="Calculadora de porcentajes">

			<div className={appStyles.topBar}>
				<ModeSegment mode={mode} onChange={setMode} />
			</div>

			<PercentageAmountInput
				value={amount}
				onChange={setAmount}
				onReset={handleReset}
			/>

			<PercentageSlider
				value={pct}
				onChange={setPct}
				min={0}
				max={100}
				quickPcts={QUICK_PCTS}
				mode={mode}
				adjustmentAmount={
					hasAmount ? formatCurrency(adjustment) : null
				}
			/>

			<PercentageSummary
				amount={parsedAmount}
				pct={pct}
				adjustment={adjustment}
				finalAmount={finalAmount}
				hasAmount={hasAmount}
				mode={mode}
			/>

		</main>
	);
}
